export default {
    print(params) {

        const page = window.open('', Math.random())

        page.document.write(`
            <head>
                <title>Etiqueta</title>

                <style>
                    * {
                        box-sizing: border-box;
                    }

                    body {
                        padding: 0 !important;
                        margin: 0 !important;
                    }

                    span {
                        font-family: Arial, Helvetica, sans-serif;
                        font-size: 8pt;
                    }

                    #label {
                        display: -ms-flexbox !important;
                        display: flex !important;
                        -ms-flex-direction: column !important;
                        flex-direction: column !important;
                        -ms-flex-pack: justify !important;
                        justify-content: space-between !important;
                        height: 100vh !important;
                        padding: 15px 7px 0 2px !important;
                    }

                    .label-row {
                        display: -ms-flexbox;
                        display: flex;
                        -ms-flex-wrap: wrap;
                        flex-wrap: wrap;
                    }

                    .label-col {
                        -ms-flex-preferred-size: 0;
                        flex-basis: 0;
                        -ms-flex-positive: 1;
                        flex-grow: 1;
                        max-width: 100%;
                        -ms-flex: 0 0 auto;
                        flex: 0 0 auto;
                        width: auto;
                        max-width: 100%;
                    }

                    .label-justify-content-start {
                        -ms-flex-pack: start !important;
                        justify-content: flex-start !important;
                    }

                    .label-justify-content-between {
                        -ms-flex-pack: justify !important;
                        justify-content: space-between !important;
                    }
                </style>
            </head>


            <div id="label">
                <div class="label-row label-justify-content-between">
                    <div class="label-col">
                        <span>${params.atendidoEm}</span>
                    </div>

                    <div class="label-col">
                        <span>${params.infraestrutura}</span>
                    </div>
                </div>

                <div class="label-row label-justify-content-start">
                    <div class="label-col">
                        <span>
                            <strong>
                                Paciente:
                                <br>
                                ${params.paciente}
                            </strong>
                        </span>
                    </div>
                </div>

                <div class="label-row label-justify-content-start">
                    <div class="label-col">
                        <span style="font-size: 10pt;"><strong>Nascimento: ${params.dataNascimento}</strong></span>
                    </div>
                </div>

                <div class="label-row label-justify-content-between">
                    <div class="label-col">
                        <span>
                            <strong>Acompanhante:</strong>
                            <br>
                            ${params.acompanhante}
                        </span>
                    </div>

                    <div class="label-col">
                        <span>${params.senha}</span>
                    </div>
                </div>
            </div>
        `)

        page.onload = () => {

            page.onafterprint = () => page.close()
            page.print()
        }
        page.document.close()
    }
}